export const auth = {
  login: {
    title: "Login",
    email: "Email",
    password: "Password",
    submit: "Login",
    noAccount: "Don't have an account?",
    registerLink: "Register here",
    success: "Login successful",
    error: "Login failed",
    errorMessage: "Please check your credentials",
    googleButton: "Continue with Google",
    githubButton: "Continue with Github",
    facebookButton: "Continue with Facebook",
    twitterButton: "Continue with Twitter",
  },
  register: {
    title: "Register",
    socialTitle: "Register with Social",
    emailTitle: "Register with Email",
    email: "Email",
    password: "Password",
    firstName: "First Name",
    lastName: "Last Name",
    submit: "Register",
    hasAccount: "Already have an account?",
    loginLink: "Login here",
    success: "Registration successful",
    error: "Registration failed",
    errorMessage: "Please try again",
    referralCode: "Registering with Referral Code",
  },
  forgotPassword: "Forgot Password",
  forgotPasswordInstructions:
    "Enter your email address and we'll send you a link to reset your password.",
  resetPassword: "Reset Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  passwordMismatch: "Passwords do not match",
  passwordResetSuccess: "Password reset successful",
  passwordResetError: "Failed to reset password",
  resetEmailSent: "Reset email sent",
  resetEmailError: "Failed to send reset email",
  sendResetEmail: "Send Reset Email",
  backToLogin: "Back to Login",
  emailVerification: "Email Verification",
  verificationSuccess: "Email verified successfully",
  verificationError: "Verification failed",
  verificationTokenMissing: "Verification token is missing",
  verificationFailed: "Failed to verify email",
  resendVerification: "Resend verification email",
  verificationEmailSent: "Verification email sent",
  verificationRequired: "Please verify your email",
};
